module.exports = __webpack_public_path__ + "static/media/video-icon.b74051a1.png";